<svg [class]="iconStyle" xmlns="http://www.w3.org/2000/svg">
  <use [attr.xlink:href]="href"></use>
</svg>

